module.exports = __webpack_public_path__ + "img/check-out.a0e68c9b.svg";